<template>
  <div class="LoginHeader">
    <div class="container">
      <img class="logo cp" :src="imagePath.zdLogo" alt="" />
      <div class="downloadAPP cp">
        <div @mouseenter="isShow = true" @mouseleave="isShow = false">
          下载APP
        </div>
        <img v-show="isShow" class="QRCode" :src="imagePath.downloadAPP" />
      </div>
    </div>
  </div>
</template>

<script>
import imagePath from "@/utils/imagePath";

export default {
  name: "LoginHeader", // 登录页头部
  data() {
    return {
      isShow: false,
      imagePath
    };
  }
};
</script>

<style scoped lang="less">
.LoginHeader {
  display: flex;
  justify-content: center;

  .container {
    display: flex;
    align-items: center;
    width: 1200px;
    height: 107px;

    .logo {
      margin-right: 30px;
      width: 230px;
      height: 73px;
    }

    .downloadAPP {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      position: relative;
      z-index: 9;
      width: 140px;
      height: 50px;
      background: #ffffff;
      font-size: 22px;
      color: #333333;
      font-weight: 600;
      text-align: center;
      border-radius: 30px;

      > div {
        margin-top: 3px;
        height: 22px;
        line-height: 22px;
      }

      .QRCode {
        position: absolute;
        top: 50px;
        margin-top: 6px;
        width: 140px;
        height: 140px;
        box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
        border-radius: 7px;
      }
    }
  }
}
</style>
